export default __webpack_public_path__ + "static/media/OPTIVenus-BoldExtended.bd7331c6.otf";